import { Input } from '@angular/core';

import { ThfBreadcrumb } from '@totvs/thf-ui';

import { convertToBoolean } from '../../utils/util';

import { ThfPageDynamicTableField } from './thf-page-dynamic-table-field.interface';

export class ThfPageDynamicListBaseComponent {

  private _autoRouter: boolean = false;
  private _columns: Array<any> = [];
  private _duplicates: Array<any> = [];
  private _fields: Array<any> = [];
  private _filters: Array<any> = [];
  private _keys: Array<any> = [];

  /**
   * @optional
   *
   * @description
   *
   * Cria automaticamente as rotas de ediÃ§Ã£o (novo/duplicate) e detalhes caso sejam definidas aÃ§Ãµes na propriedade `t-actions`
   *
   * As rotas criadas serÃ£o baseadas na propriedade `t-actions`.
   *
   * > Para o correto funcionamento nÃ£o pode haver nenhuma rota coringa (`**`) especificada.
   *
   * @default false
   */
  @Input('t-auto-router') set autoRouter(value: boolean) {
    this._autoRouter = convertToBoolean(value);
  }

  get autoRouter(): boolean {
    return this._autoRouter;
  }

  /** Objeto com propriedades do breadcrumb. */
  @Input('t-breadcrumb') breadcrumb?: ThfBreadcrumb = { items: [] };

  /**
   * @optional
   *
   * @description
   *
   * Lista dos campos usados na tabela e busca avanÃ§ada.
   *
   *
   * > Caso nÃ£o seja definido fields a tabela assumirÃ¡ o comportamento padrÃ£o.
   */
  @Input('t-fields') set fields(fields: Array<ThfPageDynamicTableField>) {
    this._fields = Array.isArray(fields) ? [...fields] : [];

    this.setFieldsProperties(this.fields);
  }

  get fields(): Array<ThfPageDynamicTableField> {
    return this._fields;
  }

  /** Endpoint da API dos recursos que serÃ£o exibidos. */
  /**
   * @description
   *
   * Endpoint usado pelo template para requisiÃ§Ã£o dos recursos que serÃ£o exibidos.
   *
   * Caso a aÃ§Ã£o `remove` estiver configurada, serÃ¡ feito uma requisiÃ§Ã£o de exclusÃ£o nesse mesmo endpoint passando os campos
   * setados como `key: true`.
   *
   * > `DELETE {end-point}/{keys}`
   *
   * ```
   *  <thf-page-dynamic-table
   *    [t-actions]="{ remove: true }"
   *    [t-fields]="[ { property: 'id', key: true } ]"
   *    t-service="/api/thf-samples/v1/people"
   *    ...>
   *  </thf-page-dynamic-table>
   * ```
   *
   * ResquisiÃ§Ã£o disparada, onde a propriedade `id` Ã© igual a 2:
   *
   * ```
   *  DELETE /api/thf-samples/v1/people/2 HTTP/1.1
   *  Host: localhost:4000
   *  Connection: keep-alive
   *  Accept: application/json, text/plain
   *  ...
   * ```
   *
   * Para a aÃ§Ã£o `removeAll`, serÃ¡ feito uma requisiÃ§Ã£o de exclusÃ£o em lote para esse mesmo endpoint passando, uma lista
   * de objetos com os campos setados como `key: true` via `payload`.
   *
   * > `DELETE {end-point}`
   *
   * > `Payload: [ {key}, {key} ... {key} ]`
   *
   * ```
   *  <thf-page-dynamic-table
   *    [t-actions]="{ removeAll: true }"
   *    [t-fields]="[ { property: 'id', key: true } ]"
   *    t-service="/api/thf-samples/v1/people"
   *    ...>
   *  </thf-page-dynamic-table>
   * ```
   *
   * ResquisiÃ§Ã£o disparada, onde foram selecionados 3 itens para serem removidos:
   *
   * ```
   *  DELETE /api/thf-samples/v1/people HTTP/1.1
   *  Host: localhost:4000
   *  Connection: keep-alive
   *  Accept: application/json, text/plain
   *  ...
   * ```
   *
   * Request payload:
   *
   * ```
   * [{"id":2},{"id":4},{"id":5}]
   * ```
   *
   * > Caso esteja usando metadados com o template, serÃ¡ disparado uma requisiÃ§Ã£o na inicializaÃ§Ã£o do template para buscar
   * > os metadados da pÃ¡gina passando o tipo do metadado esperado e a versÃ£o cacheada pelo browser.
   * >
   * > `GET {end-point}/metadata?type=list&version={version}`
   */
  @Input('t-service-api') serviceApi: string;

  /** TÃ­tulo da pÃ¡gina. */
  @Input('t-title') title: string;

  get columns() {
    return [...this._columns];
  }

  get duplicates() {
    return [...this._duplicates];
  }

  get filters() {
    return [...this._filters];
  }

  get keys() {
    return [...this._keys];
  }

  private setFieldsProperties(fields: Array<any>) {
    this._filters = fields.filter(field => field.filter === true);
    this._columns = fields.filter(field => field.visible === undefined || field.visible === true);
    this._keys = fields.filter(field => field.key === true).map(field => field.property);
    this._duplicates = fields.filter(field => field.duplicate === true).map(field => field.property);
  }

}
